/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { QuotaStatus } from '../models/QuotaStatus';

export class QuotaStatusFilters {
  '_in'?: Array<QuotaStatus>;
  'notIn'?: Array<QuotaStatus>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<QuotaStatus>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<QuotaStatus>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return QuotaStatusFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

